"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.black1 = '#040404';
exports.black2 = '#131313';
exports.black3 = '#202020';
exports.white1 = '#FFFFFF';
exports.white2 = '#FBFBFB';
exports.white3 = '#F6F6F6';
exports.grey1 = '#EBEBEB';
exports.grey2 = '#DDDDDD';
exports.grey3 = '#BFBFBF';
exports.grey4 = '#A2A1A1';
exports.grey5 = '#868686';
exports.grey6 = '#6A6A6A';
exports.grey7 = '#505050';
exports.grey8 = '#3F3F3F';
exports.grey9 = '#2E2E2E';
exports.red1 = '#FFD5D6';
exports.red2 = '#FF9292';
exports.red3 = '#F04B52';
exports.red4 = '#D0041F';
exports.red5 = '#700B04';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29sb3JzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2NvbG9ycy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFhLFFBQUEsTUFBTSxHQUFHLFNBQVMsQ0FBQztBQUNuQixRQUFBLE1BQU0sR0FBRyxTQUFTLENBQUM7QUFDbkIsUUFBQSxNQUFNLEdBQUcsU0FBUyxDQUFDO0FBRW5CLFFBQUEsTUFBTSxHQUFHLFNBQVMsQ0FBQztBQUNuQixRQUFBLE1BQU0sR0FBRyxTQUFTLENBQUM7QUFDbkIsUUFBQSxNQUFNLEdBQUcsU0FBUyxDQUFDO0FBRW5CLFFBQUEsS0FBSyxHQUFHLFNBQVMsQ0FBQztBQUNsQixRQUFBLEtBQUssR0FBRyxTQUFTLENBQUM7QUFDbEIsUUFBQSxLQUFLLEdBQUcsU0FBUyxDQUFDO0FBQ2xCLFFBQUEsS0FBSyxHQUFHLFNBQVMsQ0FBQztBQUNsQixRQUFBLEtBQUssR0FBRyxTQUFTLENBQUM7QUFDbEIsUUFBQSxLQUFLLEdBQUcsU0FBUyxDQUFDO0FBQ2xCLFFBQUEsS0FBSyxHQUFHLFNBQVMsQ0FBQztBQUNsQixRQUFBLEtBQUssR0FBRyxTQUFTLENBQUM7QUFDbEIsUUFBQSxLQUFLLEdBQUcsU0FBUyxDQUFDO0FBRWxCLFFBQUEsSUFBSSxHQUFHLFNBQVMsQ0FBQztBQUNqQixRQUFBLElBQUksR0FBRyxTQUFTLENBQUM7QUFDakIsUUFBQSxJQUFJLEdBQUcsU0FBUyxDQUFDO0FBQ2pCLFFBQUEsSUFBSSxHQUFHLFNBQVMsQ0FBQztBQUNqQixRQUFBLElBQUksR0FBRyxTQUFTLENBQUMifQ==


//////////////////
// WEBPACK FOOTER
// ./node_modules/@riiid/santa-closet-web/colors.js
// module id = 1
// module chunks = 0